/**
 * Права раздела AI-администратора по матрице 2.2 ТЗ (копия строк backend/src/core/authz/matrix.ts):
 * - диалоги и эскалации (`conversations`): FRONT_DESK — изменение; OWNER, MED_DIRECTOR, OPS_DIRECTOR — чтение;
 * - настройки AI-администратора (`assistant_settings`): OWNER, MED_DIRECTOR — изменение; FRONT_DESK — чтение;
 * - прайс, услуги, база знаний (`catalog`): OWNER, MED_DIRECTOR, FRONT_DESK — изменение; OPS_DIRECTOR, DOCTOR — чтение;
 * - дашборд клиники, обращения (`dashboard_requests`): OWNER, MED_DIRECTOR, OPS_DIRECTOR, FRONT_DESK — чтение.
 * Интерфейс только скрывает недоступные действия — права всё равно проверяет сервер (403).
 */
import type { ClinicRole } from '@/app/session/roles';

export type AssistantResource = 'conversations' | 'assistant_settings' | 'catalog' | 'dashboard_requests' | 'staff';
type Cell = 'W' | 'R' | null;

const MATRIX: Readonly<Record<AssistantResource, Readonly<Record<ClinicRole, Cell>>>> = {
  conversations: { OWNER: 'R', MED_DIRECTOR: 'R', OPS_DIRECTOR: 'R', DOCTOR: null, FRONT_DESK: 'W', HR: null, ACCOUNTANT: null },
  assistant_settings: { OWNER: 'W', MED_DIRECTOR: 'W', OPS_DIRECTOR: null, DOCTOR: null, FRONT_DESK: 'R', HR: null, ACCOUNTANT: null },
  catalog: { OWNER: 'W', MED_DIRECTOR: 'W', OPS_DIRECTOR: 'R', DOCTOR: 'R', FRONT_DESK: 'W', HR: null, ACCOUNTANT: null },
  dashboard_requests: { OWNER: 'R', MED_DIRECTOR: 'R', OPS_DIRECTOR: 'R', DOCTOR: null, FRONT_DESK: 'R', HR: null, ACCOUNTANT: null },
  staff: { OWNER: 'W', MED_DIRECTOR: 'R', OPS_DIRECTOR: 'R', DOCTOR: null, FRONT_DESK: null, HR: 'R', ACCOUNTANT: null },
};

/** Есть ли у ролей право на действие с ресурсом. */
export function canAssistant(roles: ReadonlyArray<ClinicRole>, resource: AssistantResource, action: 'read' | 'write'): boolean {
  return roles.some((role) => {
    const cell = MATRIX[resource][role];
    return cell === 'W' || (cell === 'R' && action === 'read');
  });
}

/** Роли, которым виден раздел (для реестра разделов). */
export function rolesFor(resource: AssistantResource): ClinicRole[] {
  return (Object.keys(MATRIX[resource]) as ClinicRole[]).filter((role) => MATRIX[resource][role] !== null);
}
